import React from "react";
import { Link } from "react-router-dom";
import { internalPath } from "../lib/siteUrls";

/* <Link> for same-site paths, a normal <a href> when the URL is on another domain. */
export const SiteLink = React.forwardRef(function SiteLink({ href, newTab = false, children, ...rest }, ref) {
  const path = internalPath(href);
  if (path !== null) return <Link ref={ref} to={path} {...rest}>{children}</Link>;
  const tab = newTab ? { target: "_blank", rel: "noopener noreferrer" } : {};
  return <a ref={ref} href={href} {...tab} {...rest}>{children}</a>;
});
